import React from 'react';
import '../CSS/QuemsomosAboutus.css';
import backgroundImage from '../Images/fundo2.png';
import backgroundImageWebp from '../Images/fundo2.webp';

const Termos = () => {
  return (
    <div>
      <picture>
        <source srcSet={backgroundImageWebp} type="image/webp" />
        <img src={backgroundImage} className="backImage2" alt="" loading="eager" decoding="async" />
      </picture>

      <div className="er-pageShell">
        <div className="divCenteredContent er-container">
          <div className="divBigTitle">
            <h1 className="BigTitle">Termos e Condições</h1>
          </div>

          <p className="regularText">Bem-vindo ao Escape Room Bragança! Antes de participar nas nossas experiências de jogo, por favor, leia atentamente os seguintes Termos e Condições. 
            Ao efetuar uma reserva ou utilizar os nossos serviços, você concorda em cumprir estes termos. Se tiver alguma dúvida, não hesite em entrar em contato connosco.</p>
          
          <p className="regularTextYellow">1. Identificação</p>
          <p className="regularText">Os presentes Termos e Condições regulam a utilização do website e dos serviços prestados pelo escape room, com sede em Portugal.
Ao efetuar uma reserva, comprar um voucher ou utilizar o website, o utilizador aceita os presentes Termos e Condições.</p>

          <p className="regularTextYellow">2. Serviços Prestados</p>
          <p className="regularText">A escape room disponibiliza experiências de jogo presenciais, mediante reserva prévia, bem como a venda de vouchers através do website.</p>

          <p className="regularTextYellow">3. Reservas</p>
          <p className="regularText">As reservas estão sujeitas à disponibilidade das salas e horários. O cliente é responsável por fornecer informações corretas no momento da reserva.
A escape room reserva-se no direito de cancelar ou alterar reservas em caso de força maior ou motivos operacionais, informando o cliente sempre que possível.</p>

          <p className="regularTextYellow">4. Vouchers e Pagamentos Online</p>
          <p className="regularText">Os pagamentos online estão disponíveis exclusivamente para a compra de vouchers. Os pagamentos são processados através de plataformas de pagamento seguras.
A escape room não armazena dados de pagamento. Os vouchers não têm validade e não são reembolsáveis, salvo disposição legal em contrário.</p>

          <p className="regularTextYellow">5. Cancelamentos e Não Comparência</p>
          <p className="regularText">As condições de cancelamento ou remarcação poderão variar e serão comunicadas no momento da reserva. A não comparência à hora marcada pode implicar a perda da reserva ou do voucher, sem direito a reembolso.</p>

          <p className="regularTextYellow">6. Regras de Participação</p>
          <p className="regularText">Os participantes devem cumprir as instruções fornecidas pela equipa. É proibido danificar equipamentos ou cenários.
A escape room não se responsabiliza por objetos pessoais perdidos ou danificados.</p>

          <p className="regularTextYellow">7. Câmaras de Monitorização</p>
          <p className="regularText">As salas dispõem de câmaras de monitorização apenas para acompanhamento em tempo real durante o jogo, com fins de segurança e apoio à experiência. Não existe gravação de imagem ou som.</p>

          <p className="regularTextYellow">8. Responsabilidade</p>
          <p className="regularText">A escape room não será responsável por danos resultantes de uso indevido das instalações ou do incumprimento das regras por parte dos participantes.</p>

          <p className="regularTextYellow">9. Proteção de Dados</p>
          <p className="regularText">O tratamento de dados pessoais é regulado pela Política de Privacidade, disponível no website, a qual faz parte integrante destes Termos e Condições.
O tratamento de dados pessoais é regulado pela Política de Privacidade, disponível no website, a qual faz parte integrante destes Termos e Condições.</p>

          <p className="regularTextYellow">10. Alterações</p>
          <p className="regularText">A escape room reserva-se o direito de alterar os presentes Termos e Condições a qualquer momento, sendo as alterações publicadas no website.</p>

          <p className="regularTextYellow">11. Lei Aplicável e Foro</p>
          <p className="regularText">Os presentes Termos e Condições são regidos pela lei portuguesa. Em caso de litígio, é competente o foro da comarca correspondente, com expressa renúncia a qualquer outro.</p>
        </div>
      </div>
    </div>
  );
};

export default Termos;

